import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconComposeSvg } from "./IconComposeSvg.mjs";
const IconCompose = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconComposeSvg, ...svgProps }) });
export {
  IconCompose
};
